// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","filled":"Button_filled__cN7rz","big":"Button_big__OK2JF","gradient":"Button_gradient__25V-l"};